import { initialState, IStore } from "store";
import { DocumentsAction } from "store/actions";
import { IAction } from "store/actions/i-action";
import { Document } from "store/types";

import { reducer } from "..";

reducer.createHandler(
  DocumentsAction.GetDocumentsSuccess,
  (state: IStore, { payload }: IAction<Document[]>): IStore => ({
    ...state,
    documents: payload
  })
);

reducer.createHandler(
  DocumentsAction.GetPaginatedDocumentsSuccess,
  (state: IStore, { payload }: IAction<Document[]>): IStore => ({
    ...state,
    documents: [...state.documents, ...payload]
  })
);

reducer.createHandler(
  DocumentsAction.InvalidateDocuments,
  (state: IStore): IStore => ({
    ...state,
    documents: initialState.documents
  })
);

reducer.createHandler(DocumentsAction.UpdateDocumentSuccess, (state, { payload }: IAction<Document>) => ({
  ...state,
  documents: state.documents.map((doc) => (doc.id === payload.id ? { ...doc, ...payload } : doc))
}));

reducer.createHandler(DocumentsAction.CreateDocumentSuccess, (state, { payload }: IAction<Document>) => ({
  ...state,
  documents: [...state.documents, payload]
}));

reducer.createHandler(DocumentsAction.DeleteDocumentSuccess, (state, { payload }: IAction<number>) => ({
  ...state,
  documents: state.documents.filter((doc) => doc.id !== payload)
}));
